
import React from 'react';
import { SwitchRoute } from '../../../Components/Route/SwitchRoute';
import {  VendorsRoutes } from '../../../routes';

export const VendorsLayout = () => (
  <>
    <SwitchRoute routes={VendorsRoutes} />
  </>
);
